// ContextFile.js
import { createContext } from 'react';

// Create Context
const TrackContext = createContext(false);

export { TrackContext };
